"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSwiper = void 0;
const swipe_1 = __importDefault(require("./libs/swipe"));
const touch_1 = __importDefault(require("./libs/touch"));
const ua_1 = require("./libs/ua");
const util_1 = require("./libs/util");
require("./style/swipe.scss");
let swiper;
let eventHandler;
let startPosition = {};
let positionDelta = {};
let isScrolling = false;
function initSwiper(container) {
    const nextBtns = container.querySelectorAll('.js-next');
    swiper = new swipe_1.default(container, {
        orientation: 2 /* vertical */,
    });
    window.addEventListener('resize', util_1.throttle(onResize, 250));
    if (nextBtns.length) {
        nextBtns.forEach((nextBtn) => {
            var _a;
            nextBtn.addEventListener(((_a = ua_1.uaResult === null || ua_1.uaResult === void 0 ? void 0 : ua_1.uaResult.os) === null || _a === void 0 ? void 0 : _a.isMobile) ? 'touchStart' : 'click', onClick);
        });
    }
    eventHandler = new touch_1.default({
        element: container
    });
    eventHandler.onTouchStart(onTouchStart);
    container.addEventListener('wheel', onScroll);
    container.addEventListener('keydown', onKeyDown);
    return swiper;
}
exports.initSwiper = initSwiper;
function onResize() {
    swiper === null || swiper === void 0 ? void 0 : swiper.resize();
}
function onClick() {
    const { current, slides } = swiper.slideInfo;
    if (current !== slides.length - 1) {
        swiper.next();
    }
}
function onTouchStart(event) {
    const touches = event.touches[0];
    // measure start values
    startPosition = {
        x: touches.pageX,
        y: touches.pageY,
        time: Date.now(),
    };
    isScrolling = false;
    positionDelta = {};
    eventHandler.onTouchMove(onTouchMove);
    eventHandler.onTouchEnd(onTouchEnd);
}
function onTouchMove(event) {
    if (event.touches.length > 1 || (event.scale && event.scale !== 1)) {
        return;
    }
    const dir = swiper.options.orientation === 2 /* vertical */ ? 'y' : 'x';
    const { current: index, slideDataList } = swiper.slideInfo;
    const touches = event.touches[0];
    positionDelta = {
        x: touches.pageX - startPosition.x,
        y: touches.pageY - startPosition.y,
    };
    event.preventDefault();
    swiper.translate(index - 1, positionDelta[dir] + slideDataList[index - 1], 0);
    swiper.translate(index, positionDelta[dir] + slideDataList[index], 0);
    swiper.translate(index + 1, positionDelta[dir] + slideDataList[index + 1], 0);
}
function onTouchEnd() {
    const dir = swiper.options.orientation === 2 /* vertical */ ? 'y' : 'x';
    const { current: index, slides, slideSize } = swiper.slideInfo;
    const duration = Date.now() - startPosition.time;
    const isValidSlide = (duration < 250
        && Math.abs(positionDelta[dir]) > 20)
        || Math.abs(positionDelta[dir]) > slideSize / 4;
    const isPastBounds = (!index && positionDelta[dir] > 0)
        || (index == slides.length - 1 && positionDelta[dir] < 0);
    const direction = positionDelta[dir] < 0;
    if (isValidSlide && !isPastBounds) {
        // 正向滚动
        if (direction) {
            swiper.next();
        }
        else {
            swiper.prev();
        }
    }
    else {
        // 复位
        swiper.slide(index);
    }
    eventHandler.offTouchMove(onTouchMove);
    eventHandler.offTouchEnd(onTouchEnd);
}
function onScroll(event) {
    const { current: index, slides } = swiper.slideInfo;
    const dir = swiper.options.orientation === 2 /* vertical */ ? 'y' : 'x';
    const { [`delta${dir.toUpperCase()}`]: delta } = event;
    if (swiper.slideInfo.isInAinmation) {
        return;
    }
    if (delta > 0 && index !== slides.length - 1) {
        swiper.next();
    }
    else if (delta < 0 && index !== 0) {
        swiper.prev();
    }
}
function onKeyDown(event) {
    if (swiper.slideInfo.isInAinmation) {
        return;
    }
    const { current: index, slides } = swiper.slideInfo;
    switch (event.key) {
        case 'ArrowUp':
            if (index !== 0) {
                swiper.prev();
            }
            break;
        case 'ArrowDown':
            if (index !== slides.length - 1) {
                swiper.next();
            }
            break;
    }
}
